<template>
  <div class="main-panel">
    <div class="nav-bar-operations">
      <img src="@/assets/logogruas.png" alt="HomePage" class="logo-button" @click="goMaintenance" />
    </div>

    <header class="header">
      <div class="header__left">
        <div class="avatar" aria-hidden="true">!</div>
        <div class="greet">
          <h1>Reportes de fallas</h1>
          <p class="sub">Crea reportes de fallas mecanicas y da seguimiento.</p>
        </div>
      </div>
      <div class="header__right">
        <button class="btn btn--ghost" @click="goMaintenance">Regresar</button>
      </div>
    </header>

    <section class="menu-shell">
      <article
        v-if="canCreate"
        class="menu-item menu-item--report"
        role="link"
        tabindex="0"
        @click="go('/maintenance/malfunction-reports/new')"
        @keyup.enter="go('/maintenance/malfunction-reports/new')"
      >
        <div class="menu-item__left">
          <span class="menu-icon">📝</span>
          <div class="menu-copy">
            <h2>Nuevo reporte de falla</h2>
            <p>Registra una nueva falla con unidad, sistema y descripcion.</p>
          </div>
        </div>
        <router-link class="btn btn--primary" to="/maintenance/malfunction-reports/new">Entrar</router-link>
      </article>

      <article
        v-if="canReview || canCreate"
        class="menu-item menu-item--admin"
        role="link"
        tabindex="0"
        @click="go('/maintenance/malfunction-reports/review')"
        @keyup.enter="go('/maintenance/malfunction-reports/review')"
      >
        <div class="menu-item__left">
          <span class="menu-icon">🛠️</span>
          <div class="menu-copy">
            <h2>Revisar reportes de fallas</h2>
            <p>Consulta reportes y agrega comentarios de seguimiento.</p>
          </div>
        </div>
        <router-link class="btn btn--primary" to="/maintenance/malfunction-reports/review">Entrar</router-link>
      </article>
    </section>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'MalfunctionReportsModule',
  data() {
    return {
      permissions: [],
    }
  },
  computed: {
    canCreate() {
      return this.hasPerm('maintenance.create_incident')
    },
    canReview() {
      return this.hasPerm('maintenance.view_incident_table')
    },
  },
  created() {
    this.fetchCurrentUser()
  },
  methods: {
    hasPerm(perm) {
      if (!perm) return false
      if (this.permissions.includes(perm)) return true
      return this.permissions.includes(`access_control.${perm}`)
    },
    async fetchCurrentUser() {
      const apiDirectory = process.env.API_DIRECTORY
      try {
        const { data } = await axios.get(`${apiDirectory}/current-user/`, {
          headers: { Authorization: 'Token ' + localStorage.getItem('authToken') },
        })
        this.permissions = data.permissions || []
        if (!this.canCreate && !this.canReview) {
          this.$router.push({ path: '/modulo-mantenimiento' })
        }
      } catch (error) {
        this.$router.push({ path: '/modulo-mantenimiento' })
      }
    },
    go(path) {
      this.$router.push(path)
    },
    goMaintenance() {
      this.$router.push({ path: '/modulo-mantenimiento' })
    },
  },
}
</script>

<style scoped>
.main-panel { min-height: 100vh; background: #f3f6fd; padding: 12vh 24px 48px; }
.nav-bar-operations { position: absolute; top: 0; left: 0; width: 100vw; height: 10vh; background-color: #ffc434; z-index: 1000; display: flex; align-items: center; padding-left: 16px; }
.logo-button { height: 55%; object-fit: contain; cursor: pointer; }
.header { margin-top: 12px; display: flex; align-items: center; justify-content: space-between; gap: 16px; background: rgba(255, 255, 255, 0.78); border: 1px solid rgba(15, 23, 42, 0.08); border-radius: 16px; padding: 14px 18px; }
.header__left { display: flex; align-items: center; gap: 14px; }
.avatar { width: 48px; height: 48px; border-radius: 14px; display: grid; place-items: center; background: linear-gradient(135deg, #ffc434, #ffe188); color: #3a2a00; font-weight: 800; }
.greet h1 { font-size: 1.2rem; color: #0f172a; margin: 0; }
.greet .sub { margin: 2px 0 0; color: #667085; font-size: .92rem; }
.menu-shell { max-width: 860px; margin: 16px auto 0; display: grid; gap: 12px; }
.menu-item { border-radius: 16px; border: 1px solid #e5e7eb; background: #fff; box-shadow: 0 10px 20px rgba(15, 23, 42, 0.08); padding: 14px 16px; display: flex; align-items: center; justify-content: space-between; gap: 12px; cursor: pointer; transition: transform .16s ease, box-shadow .16s ease; }
.menu-item:hover { transform: translateY(-1px); box-shadow: 0 16px 22px rgba(15, 23, 42, 0.12); }
.menu-item__left { display: flex; align-items: center; gap: 12px; min-width: 0; }
.menu-icon { width: 40px; height: 40px; border-radius: 10px; display: grid; place-items: center; font-size: 1.15rem; flex: 0 0 auto; }
.menu-item--report .menu-icon { background: rgba(37, 99, 235, 0.14); }
.menu-item--admin .menu-icon { background: rgba(8, 145, 178, 0.16); }
.menu-copy h2 { margin: 0; color: #0f172a; font-size: 1rem; }
.menu-copy p { margin: 3px 0 0; color: #475467; font-size: 0.9rem; }
.btn { display: inline-flex; align-items: center; gap: 8px; padding: 10px 14px; border-radius: 10px; border: 1px solid transparent; cursor: pointer; text-decoration: none; font-weight: 700; transition: all 0.16s ease; }
.btn--primary { background: #2563eb; color: #fff; }
.btn--ghost { background: #fff; border-color: #d0d7de; color: #0f172a; }
.btn--primary:hover { box-shadow: 0 10px 20px rgba(37, 99, 235, 0.35); }
</style>
